import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { TagModule } from 'primeng/tag'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import { processStatusTagTypeMap } from '@flowx/designer/modules/core/dictionary/common.types'

@Component({
  selector: 'flx-process-instance-details-panel-header',
  imports: [FlxIconModule, TagModule, CdkCopyToClipboard],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './process-instance-details-panel-header.component.html',
})
export class ProcessInstanceDetailsPanelHeaderComponent {
  name = input.required<string>()
  uuid = input.required<string>()
  state = input.required<string>()
  copiedTextToClipboard = false
  severity = computed(() => {
    const state = this.state()
    return processStatusTagTypeMap[state] || 'info'
  })

  onCopyToClipboardSuccess(): void {
    this.copiedTextToClipboard = true
    setTimeout(() => (this.copiedTextToClipboard = false), 2000)
  }
}
